import { FormattedMessage } from 'react-intl';
import { Locale, Position } from '@synergy/models';
import { connect } from 'react-redux';
import { getLocalizedString, padZeroLeft } from '@synergy/utils';

import { AppState } from '../../../../store/models/app-state';
import { BaseAutocompleteSuggestionType } from '../../autocomplete-list/pool-autocomplete-list';
import { Contact } from '../../../models/contact';
import { PoolFormAutocompleteList, PoolFormAutocompleteListProps } from '../../abstract/form-autocomplete-list';
import { User } from '../../../models/user';
import { fetchUsers } from '../../../actions/contacts-logins-actions';
import { localesSelector } from '../../../selectors/locale-selectors';

interface PartialContact extends BaseAutocompleteSuggestionType {
    fullName: string;
    positionName: string;
}

interface PoolCustomerContactAutocompleteListProps extends PoolFormAutocompleteListProps<Contact, PartialContact> {
    items: Contact[];
    user: User | null;
    positions: Position[];
    locales: Locale[];
    fetchUsers: (searchParams: URLSearchParams) => void;
}

class PoolCustomerContactAutocompleteListBase extends PoolFormAutocompleteList<
    Contact,
    PartialContact,
    PoolCustomerContactAutocompleteListProps
> {
    public override label = (<FormattedMessage id="app.label.customer" />);

    public override componentDidMount() {
        this.props.fetchUsers(new URLSearchParams());
        super.componentDidMount();
    }

    public getSuggestionValue = (suggestion: PartialContact) => suggestion && suggestion.fullName;

    public override handleValueChanged(search: string) {
        this.props.fetchUsers(new URLSearchParams({ search }));
    }

    public getPartial = (items: Contact[]): PartialContact[] => {
        return items.map(contact => {
            const position = this.props.positions.find(pos => pos.id === contact.positionId);
            return {
                id: padZeroLeft(contact.id, 5),
                fullName: contact.fullName,
                positionName: getLocalizedString(this.props.locales, position?.name),
            };
        });
    };
}

const mapStateToProps = (state: AppState) => ({
    items: state.contactsLogins.paginatedUsers.items,
    user: state.user,
    positions: state.positions.positions,
    locales: localesSelector(state),
});

export const PoolCustomerContactAutocompleteList = connect(mapStateToProps, {
    fetchUsers,
})(PoolCustomerContactAutocompleteListBase);
